The response from the `postPositionProfileForOpening` mutation.
